import React from 'react';
import {SecSubTitle, SecTitle, ServiceBoxTwo, TitleWrap} from '../../components';

// Service Data
import serviceData from '../../data/service.json';

const ServiceTwo = ({className})=> {
    const data = [
        {
            "id": "1",
            "path": "/e-invoicing-for-ksa",
            "image": "images/e-invoice/e-invoice-zatka.png",
            "icon": "images/icon/sr-icon-3-3.png",
            "bgShape": "images/bg/sr-box-bg-1.jpg",
            "bgShape2": "images/shape/sr-bg-shape-2-1.png",
            "title": "KSA (ZATCA Compliance)",
            "text": "Saudi Arabia has implemented E-Invoicing in two phases under ZATCA. From Phase 1's generation of structured invoices to Phase 2's integration with ZATCA’s systems, our solution is fully aligned with regulatory demands, including QR codes, UUIDs, and e-signatures."
        },
        {
            "id": "2",
            "path": "/e-invoicing-for-uae",
            "image": "images/e-invoice/e-invoice-fta.png",
            "icon": "images/icon/sr-icon-3-3.png",
            "bgShape": "images/bg/sr-box-bg-1.jpg",
            "bgShape2": "images/shape/sr-bg-shape-2-1.png",
            "title": "UAE (FTA Readiness)",
            "text": "The UAE is actively advancing toward nationwide E-Invoicing, with the Federal Tax Authority introducing digital invoicing infrastructure. Our platform is built with UAE readiness in mind—ensuring seamless alignment with upcoming mandates."
        },
    ]


    return (
        <div className={`space-top background-image ${className || ''}`}
             style={{backgroundImage: 'url(images/bg/sr-bg-1-1.png)'}}>
            <div className="container">
                <TitleWrap className="text-center">
                    <SecTitle className="h1 text-capitalize">Regional Compliance</SecTitle>
                </TitleWrap>
                <div className="row">
                    {data?.map(item => (
                        <div className="col-lg-6" key={item.id}>
                            <ServiceBoxTwo path={item.path}
                                           number={'0' + item.id}
                                           bgImage={item.bgShape2}
                                           icon={item.icon}
                                           title={item.title}
                                           text={item.text}
                                           image={item.image}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
};

export default ServiceTwo;